import { render, staticRenderFns } from "./member_account_supdeduct_detail.vue?vue&type=template&id=3ec66e1e&scoped=true&"
import script from "./member_account_supdeduct_detail.vue?vue&type=script&lang=js&"
export * from "./member_account_supdeduct_detail.vue?vue&type=script&lang=js&"
import style0 from "./member_account_supdeduct_detail.vue?vue&type=style&index=0&id=3ec66e1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec66e1e",
  null
  
)

export default component.exports